/**
 * @generated SignedSource<<e4463caf8603930c94e279520b7c5efa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsWordpressArticlesWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedWordpressArticlesWrapper_viewer">;
  readonly " $fragmentType": "SbRespInteriorsWordpressArticlesWrapper_viewer";
};
export type SbRespInteriorsWordpressArticlesWrapper_viewer$key = {
  readonly " $data"?: SbRespInteriorsWordpressArticlesWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsWordpressArticlesWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsWordpressArticlesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedWordpressArticlesWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d3b28eea60ed9f75fec5509c8ab252a5";

export default node;
